import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Liuyao from "./components/liuyao/Liuyao";
import LiuyaoDetail from "./components/liuyao/LiuyaoDetail";
import LiuyaoHistory from "./components/liuyao/LiuyaoHistory";
import LiuyaoReward from "./components/liuyao/LiuyaoReward";
import PortalIndex from "./components/portal_index";
import SiteFooter from "./components/SiteFooter";

function App_liuyao() {
  const [currentView, setCurrentView] = useState("liuyao");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setIsLoggedIn(false);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar
        isLoggedIn={isLoggedIn}
        onLogout={handleLogout}
      />
      <main className="w-full">
        <Routes>
          <Route path="/index" element={<Liuyao />} />     
          <Route path="/explore" element={<PortalIndex />} />
          <Route path="/LiuyaoDetail" element={<LiuyaoDetail />} /> 
          <Route path="/:id" element={<LiuyaoDetail />} />
          <Route path="/LiuyaoHistory" element={<LiuyaoHistory />} />
          <Route path="/:id/reward" element={<LiuyaoReward />} />      
          <Route path="*" element={<Navigate to="/liuyao" replace />} />
        </Routes>
      </main>
      
      <SiteFooter />
    </div>
  );
}

export default App_liuyao;